import React, { useState } from 'react';
import './AddNumberOfTaxiForRentFormDash.css';
import axios from 'axios';

const AddNumberOfTaxiForRentFormDash = () => {
  const [formData, setFormData] = useState({
    Name: '',
    Type: 'להשכרה',
    Date: '',
    Immediately: '',
    Price: '',
    Phone: ''
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // פורמט מחיר עם ₪ ופסיקים
    const formatPrice = (value) => {
      const num = parseFloat(value.toString().replace(/[^0-9.]/g, ''));
      if (isNaN(num)) return '';
      return num.toLocaleString('he-IL') + ' ₪';
    };
  
    const dataToSend = {
      ...formData,
      Price: formatPrice(formData.Price)
    };
  
    try {
      const response = await axios.post('/api/numbertaxiforrent/add', dataToSend);
  
      if (response.data.success) {
        alert('הזכות נוספה בהצלחה!');
        setFormData({
          Name: '',
          Type: 'להשכרה',
          Date: '',
          Immediately: '',
          Price: '',
          Phone: ''
        });
      } else {
        alert('אירעה שגיאה בעת ההוספה');
      }
    } catch (error) {
      console.error('❌ שגיאה בשליחת הטופס:', error);
      alert('שגיאה בחיבור לשרת');
    }
  };
  

  return (
<form className="AddNumberOfTaxiForRentFormDash_Form" onSubmit={handleSubmit}>
  <h2 className="AddNumberOfTaxiForRentFormDash_Title">הוספת זכות ציבורית</h2>

  <input
    type="text"
    name="Name"
    placeholder="שם"
    value={formData.Name}
    onChange={handleChange}
    required
    className="AddNumberOfTaxiForRentFormDash_Input_Name"
  />

  <select
    name="Type"
    value={formData.Type}
    onChange={handleChange}
    required
    className="AddNumberOfTaxiForRentFormDash_Select_Type"
  >
    <option value="להשכרה">להשכרה</option>
    <option value="למכירה">למכירה</option>
  </select>

  <input
    type="date"
    name="Date"
    value={formData.Date}
    onChange={handleChange}
    required
    disabled={formData.Immediately === "כן"}
    className="AddNumberOfTaxiForRentFormDash_Input_Date"
  />

  <select
    name="Immediately"
    value={formData.Immediately}
    onChange={(e) => {
      const value = e.target.value;
      setFormData((prev) => ({
        ...prev,
        Immediately: value,
        Date: value === "כן" ? '' : prev.Date,
      }));
    }}
    required
    className="AddNumberOfTaxiForRentFormDash_Select_Immediately"
  >
    <option value="">האם מיידי?</option>
    <option value="כן">כן</option>
    <option value="לא">לא</option>
  </select>

  <input
    type="text"
    name="Price"
    placeholder="מחיר"
    value={formData.Price}
    onChange={handleChange}
    required
    className="AddNumberOfTaxiForRentFormDash_Input_Price"
  />

  <input
    type="text"
    name="Phone"
    placeholder="טלפון"
    value={formData.Phone}
    onChange={handleChange}
    required
    className="AddNumberOfTaxiForRentFormDash_Input_Phone"
  />

  <button type="submit" className="AddNumberOfTaxiForRentFormDash_Button_Submit">
    הוסף
  </button>
</form>

  );
};

export default AddNumberOfTaxiForRentFormDash;
